export default __webpack_public_path__ + "09a81ff2a623b3c8e5837b370bb4e5e1.svg";